import React, { useEffect } from "react"
import lodash from "lodash"
import styled from "styled-components"

import { FieldPrefix } from "components/Field"
// import CustomsItemForm from "components/CustomsForm/CustomsItem/Form"
import CustomsItemForm from "containers/OrderEntry/Form/Customs/CustomsItem/CustomsItemForm"

const Wrapper = styled.div``

const Form = props => {
  const { form, initialValues, setForm } = props

  useEffect(() => {
    // console.log("init values", initialValues)
    setForm(form)
    form.batch(() => {
      lodash.forEach(initialValues, (value, key) => {
        form.change(key, value)
      })
    })
  }, [])

  return (
    <Wrapper>
      <CustomsItemForm disableSearchAutocomplete simpleZtn />
      {/* <CustomsItemForm name="item" /> */}
    </Wrapper>
  )
}

export default Form
